/**
 * Business-language message catalogue (constitution VI, RF-21).
 *
 * Every text a user can see lives here, separated from technical exception handling.
 * Messages are Spanish product copy: they say what to do next and never expose internals
 * (no stack traces, exception names, paths, table names or internal ids).
 * Codes come from contracts/http-api.md, contracts/archivo-listado.md and spec exceptions E-1..E-6.
 */
export const MENSAJES = {
    // generic
    ERROR_INESPERADO: 'No pudimos completar la acción. Intenta de nuevo en unos minutos y, si persiste, avisa al administrador.',
    NO_ENCONTRADO: 'Lo que buscas no existe o ya no está disponible.',
    DATOS_INVALIDOS: 'Revisa los datos ingresados e intenta de nuevo.',
    DEMASIADOS_INTENTOS: 'Hiciste demasiados intentos seguidos. Espera unos minutos y vuelve a intentar.',
    // admin session and users (RF-01)
    CREDENCIALES_INVALIDAS: 'Usuario o contraseña incorrectos.',
    SESION_REQUERIDA: 'Tu sesión terminó. Ingresa de nuevo para continuar.',
    USUARIO_INACTIVO: 'Tu usuario está desactivado. Contacta a un operador de Coninsa.',
    CAMBIO_CLAVE_REQUERIDO: 'Debes cambiar tu contraseña antes de continuar.',
    PERFIL_CONSULTA: 'Tu perfil es de consulta. Esta acción solo la puede hacer un operador.',
    CLAVE_ACTUAL_INCORRECTA: 'La contraseña actual no coincide.',
    CLAVE_DEBIL: 'La contraseña nueva debe tener al menos 12 caracteres.',
    CORREO_YA_EXISTE: 'Ya existe un usuario con ese correo.',
    NO_PUEDES_DESACTIVARTE: 'No puedes desactivar tu propio usuario. Pídeselo a otro operador.',
    USUARIO_NO_ENCONTRADO: 'Ese usuario no existe.',
    // configuration (RF-06)
    VIGENCIA_FUERA_DE_RANGO: 'La vigencia debe estar entre 1 y 90 días.',
    HISTORIAL_FUERA_DE_RANGO: 'El histórico visible debe estar entre 1 y 24 meses.',
    // listing upload (RF-02, RF-03, E-5)
    ARCHIVO_REQUERIDO: 'Adjunta el archivo del listado en formato .xlsx o .csv.',
    FORMATO_NO_SOPORTADO: 'El archivo debe ser .xlsx o .csv.',
    ARCHIVO_DEMASIADO_GRANDE: 'El archivo supera el tamaño máximo de 10 MB.',
    PERIODO_INVALIDO: 'El periodo debe tener el formato AAAA-MM, por ejemplo 2026-09.',
    COLUMNA_FALTANTE: 'El archivo no tiene la columna {columna}. Revisa el formato y vuelve a cargarlo.',
    ARCHIVO_VACIO: 'El archivo no tiene filas de datos.',
    CELDA_VACIA: 'La fila {fila} no tiene valor en la columna {columna}.',
    CORREO_INVALIDO: 'El correo de la fila {fila}, columna {columna}, no tiene un formato válido.',
    LISTADO_RECHAZADO: 'El archivo fue rechazado y el listado vigente no cambió. Corrige lo indicado y vuelve a cargarlo.',
    LISTADO_SIN_CAMBIOS: 'Es el mismo archivo que ya está vigente. No hubo cambios.',
    CORREO_UNIFICADO: 'El correo {correo} administra varios centros de costo y recibirá un solo enlace.',
    FILA_DUPLICADA: 'La fila {fila} estaba repetida y se tomó una sola vez.',
    CENTRO_COSTO_REPETIDO: 'El centro de costo {centro_costo} aparece en varias filas. Se unieron sus correos en una sola.',
    COLUMNA_IGNORADA: 'La columna {columna} no se usa y fue ignorada.',
    SIN_LISTADO_VIGENTE: 'No hay un listado vigente. Carga el archivo del periodo primero.',
    DRIVE_NO_CONFIGURADO: 'El portal no tiene configurada la carpeta compartida. Carga el archivo desde la pantalla de centros de costo y correos.',
    DRIVE_NO_DISPONIBLE: 'No pudimos leer la carpeta compartida en este momento. Intenta de nuevo en unos minutos.',
    DRIVE_SIN_ARCHIVO: 'La carpeta compartida no tiene un archivo .xlsx o .csv de centros de costo y correos.',
    // publication (RF-19, RF-20, Decision 2)
    PUBLICACION_EN_CURSO: 'La publicación de {periodo} ya está en curso.',
    PUBLICACION_COMPLETADA: 'El periodo {periodo} ya fue publicado.',
    PUBLICACION_SIN_DOCUMENTOS: '{n} centros de costo no tienen documentos para {periodo}. No se publicó nada. Revisa la carga de documentos y vuelve a publicar.',
    PUBLICACION_TIPO_DESCONOCIDO: 'Hay documentos en una carpeta que no corresponde a ningún tipo conocido. No se publicó nada.',
    PUBLICACION_FALLIDA: 'La publicación de {periodo} no pudo completarse. Puedes volver a intentarla; lo ya generado se conserva.',
    // third-party portal (RF-08, RF-12, E-1, E-2, E-4)
    ACCESO_VENCIDO: 'El enlace venció. Escribe tu correo y te enviamos uno nuevo.',
    ACCESO_NO_AUTORIZADO: 'No tienes acceso a ese centro de costo.',
    DOCUMENTO_NO_DISPONIBLE: 'Este documento no está disponible en este momento. Ya avisamos al equipo de Coninsa.',
    RENOVACION_ENVIADA: 'Si el correo está registrado, recibirá un enlace nuevo en unos minutos.',
    // delivery panel (RF-15, RF-16)
    REENVIO_PROGRAMADO: 'El acceso fue reenviado a {correo}.',
    DESTINATARIO_NO_ENCONTRADO: 'Ese destinatario no está en el listado vigente.',
};
/** Renders a catalogue message, replacing `{placeholders}` with the given values. */
export function mensaje(codigo, valores = {}) {
    return MENSAJES[codigo].replace(/\{(\w+)\}/g, (_, k) => k in valores ? String(valores[k]) : `{${k}}`);
}
export function esCodigoMensaje(valor) {
    return Object.prototype.hasOwnProperty.call(MENSAJES, valor);
}
//# sourceMappingURL=mensajes.js.map